import { useState, useEffect } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface WorkspaceSettingsModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  workspaceName: string
  onRenameWorkspace?: (name: string) => void
}

export function WorkspaceSettingsModal({
  open,
  onOpenChange,
  workspaceName,
  onRenameWorkspace,
}: WorkspaceSettingsModalProps) {
  const [name, setName] = useState(workspaceName)

  useEffect(() => {
    if (open) {
      /* eslint-disable react-hooks/set-state-in-effect -- hydrate from prop each time modal opens */
      setName(workspaceName)
      /* eslint-enable react-hooks/set-state-in-effect */
    }
  }, [open, workspaceName])

  const handleSave = () => {
    if (name.trim() && name !== workspaceName) {
      onRenameWorkspace?.(name.trim())
    }
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>Workspace Settings</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-1.5 py-2">
          <label className="text-sm font-medium text-foreground">Workspace Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="h-9 rounded-md border border-border bg-background px-3 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
          />
        </div>

        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            className="bg-pharma-primary hover:bg-pharma-primary/90 text-white"
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
